const normalizeReminderKey = (reminderName) =>
    (reminderName || '').trim().toUpperCase().replace(/\s+/g, '_');

export const TEMPLATE_TYPE_GROUPS = [
    {
        id: 'appointment-reminders',
        label: 'Appointment Reminders',
        icon: 'bi-calendar-check',
        types: [
            'PREBOOKED_REMINDER',
            'FIRST_REMINDER',
            'SECOND_REMINDER',
            'LAST_DAY_REMINDER',
            'SAME_DAY_REMINDER',
            'APPOINTMENT_CONFIRMATION',
            'APPOINTMENT_SUMMARY',
            'EDGE_REMINDER',
            'RESCHEDULE_FOLLOW_UPS',
        ],
    },
    {
        id: 'recall-follow-up',
        label: 'Recall & Follow-up',
        icon: 'bi-arrow-repeat',
        types: [
            'RECALL',
            'RECALL_REMINDER',
            'RECALL_THIRD_REMINDER',
            'RECALL_FOURTH_REMINDER',
            'RECALL_STATUS',
        ],
    },
    {
        id: 'patient-engagement',
        label: 'Patient Engagement',
        icon: 'bi-people',
        types: [
            'WELCOME',
            'CLINIC_WELCOME',
            'BIRTHDAY',
            'SURVEY',
            'SURVEY_REMINDER',
            'THANK_YOU',
            'THANK_YOU_POST_EYE_EXAM',
            'THANK_YOU_LENS_PURCHASE',
            'THANK_YOU_GLASS_PURCHASE',
            'ARTICLE',
            'PATIENT_CONSENT',
            'REPUTATION_COMMENT',
        ],
    },
    {
        id: 'orders-pickups',
        label: 'Orders & Pickups',
        icon: 'bi-bag-check',
        types: [
            'GL_PICKUP',
            'CL_PICKUP',
            'CL_REPLACE',
            'CL_REORDER',
            'GL_PICKUP_CONFIRMATION',
            'CL_PICKUP_CONFIRMATION',
            'GL_PICKUP_SUMMARY',
            'CL_PICKUP_SUMMARY',
            'CL_ORDER_REQUEST',
            'CL_ORDER_REQUEST_ACK',
        ],
    },
    {
        id: 'booking',
        label: 'Booking & Requests',
        icon: 'bi-calendar-plus',
        types: ['BOOKING_SUMMARY', 'BOOKING_REQUEST', 'BOOKING_REQUEST_ACKNOWLEDGE'],
    },
    {
        id: 'summaries-reports',
        label: 'Summaries & Reports',
        icon: 'bi-file-earmark-bar-graph',
        types: [
            'RECALL_REPORT',
            'RECALL_MONTHLY_REPORT',
            'SURVEY_SUMMARY',
            'INVALID_DETAILS_SUMMARY',
            'INVALID_PHONE',
            'STATS_CLINIC',
        ],
    },
    {
        id: 'other',
        label: 'Other',
        icon: 'bi-three-dots',
        types: [
            'OTHER',
            'CLINIC_EMAIL',
            'CLINIC_SMS',
            'CLINIC_INVOICE',
            'BLAST',
            'NEWSLETTER',
            'EMAIL_VERIFICATION',
            'TELEPHONE_VERIFICATION',
            'PASSWORD_RESET',
        ],
    },
];

const GROUP_LOOKUP = TEMPLATE_TYPE_GROUPS.reduce((lookup, group) => {
    group.types.forEach((type, index) => {
        lookup.set(type, { groupId: group.id, sortIndex: index });
    });
    return lookup;
}, new Map());

const GROUP_ORDER = TEMPLATE_TYPE_GROUPS.reduce((order, group, index) => {
    order.set(group.id, index);
    return order;
}, new Map());

export const groupTemplatesByType = (templates = []) => {
    const buckets = TEMPLATE_TYPE_GROUPS.reduce((acc, group) => {
        acc[group.id] = [];
        return acc;
    }, {});

    templates.forEach((template) => {
        const key = normalizeReminderKey(template.reminderName);
        const match = GROUP_LOOKUP.get(key);

        if (match) {
            buckets[match.groupId].push({ template, sortIndex: match.sortIndex });
        } else {
            buckets.other.push({ template, sortIndex: Number.MAX_SAFE_INTEGER });
        }
    });

    return TEMPLATE_TYPE_GROUPS.map((group) => ({
        ...group,
        templates: (buckets[group.id] || [])
            .sort(
                (a, b) =>
                    a.sortIndex - b.sortIndex ||
                    (a.template.reminderName || '').localeCompare(b.template.reminderName || '')
            )
            .map(({ template }) => template),
    }))
        .filter((group) => group.templates.length > 0)
        .sort((a, b) => GROUP_ORDER.get(a.id) - GROUP_ORDER.get(b.id));
};

export const formatReminderLabel = (reminderName) => {
    if (!reminderName) return '—';

    return reminderName
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};
